import { render, staticRenderFns } from "./SettingsRow.vue?vue&type=template&id=86896474&scoped=true&"
import script from "./SettingsRow.vue?vue&type=script&lang=js&"
export * from "./SettingsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86896474",
  null
  
)

export default component.exports